function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-02-beauty-appearance",
  transform: "translate(-40.429 -44.544)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2568",
  "data-name": "Group 2568",
  transform: "translate(41.929 46.615)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2566",
  "data-name": "Group 2566",
  transform: "translate(12.057 22.484)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2565",
  "data-name": "Group 2565",
  transform: "translate(0 6.773)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3640",
  "data-name": "Path 3640",
  d: "M92.656,99.586s-.757,11,.344,14.285a15.522,15.522,0,0,0,3.09,5.5",
  transform: "translate(-65.658 -88.122)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3641",
  "data-name": "Path 3641",
  d: "M61.53,113.887c2.045-3.7,0-15.111,0-15.111",
  transform: "translate(-58.519 -87.934)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3642",
  "data-name": "Path 3642",
  d: "M57.613,88.394c.577,2.884,1.91,4.946,3.011,7.121,3.254,6.376,7.528,9.606,12.155,9.606,4.49,0,8.63-2.908,11.831-8.983a113.287,113.287,0,0,0,5.138-11.464",
  transform: "translate(-57.613 -84.673)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_158",
  "data-name": "Ellipse 158",
  cx: 1.577,
  cy: 1.577,
  r: 1.577,
  transform: "translate(20.014 0.583)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_159",
  "data-name": "Ellipse 159",
  cx: 1.576,
  cy: 1.576,
  r: 1.576,
  transform: "translate(7.191 0.584)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3643",
  "data-name": "Path 3643",
  d: "M61.78,77.625c.644-.88,2.144-1.762,4.788-1.762s3.9.742,4.789,1.762",
  transform: "translate(-58.577 -75.863)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3644",
  "data-name": "Path 3644",
  d: "M80.478,77.625c.647-.88,2.142-1.762,4.789-1.762s3.9.742,4.789,1.762",
  transform: "translate(-62.901 -75.863)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3645",
  "data-name": "Path 3645",
  d: "M76.557,99.437c-2.1,0-3.589-1.909-4.008-2.386a16.7,16.7,0,0,1,2.564-.838c.447,0,.764.43,1.422.43.386,0,.743-.39,1.157-.385a21.955,21.955,0,0,1,2.783.794C80.056,97.528,78.754,99.437,76.557,99.437Z",
  transform: "translate(-61.067 -80.569)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3646",
  "data-name": "Path 3646",
  d: "M94.367,99.5h6.072c.111,0,.178.344.131.536a6.466,6.466,0,0,0-.155,1.372,5.8,5.8,0,0,0,6,5.761c3.3,0,5.981-2.277,5.981-5.587a8.656,8.656,0,0,0-.2-1.66.4.4,0,0,1,.086-.424h6.69",
  transform: "translate(-54.055 -58.844)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2567",
  "data-name": "Group 2567",
  transform: "translate(42.689 49.265)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_160",
  "data-name": "Ellipse 160",
  cx: 0.454,
  cy: 0.454,
  r: 0.454,
  transform: "translate(7.621 2.54)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_161",
  "data-name": "Ellipse 161",
  cx: 0.635,
  cy: 0.635,
  r: 0.635,
  transform: "translate(12.704 6.896)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_162",
  "data-name": "Ellipse 162",
  cx: 1.542,
  cy: 1.542,
  r: 1.542,
  transform: "translate(15.879 1.18)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_163",
  "data-name": "Ellipse 163",
  cx: 1.905,
  cy: 1.905,
  r: 1.905,
  transform: "translate(4.266 7.168)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_164",
  "data-name": "Ellipse 164",
  cx: 1.634,
  cy: 1.634,
  r: 1.634,
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3649",
  "data-name": "Path 3649",
  d: "M48.689,46.68s-6.76,8.858-6.76,23.342c0,12.222,9.618,24.134,9.618,24.134s.774-16.786,6.8-27.116A42.341,42.341,0,0,1,79.854,49.155a22.045,22.045,0,0,1,7.169,10.433c2,6.394-1.27,16.966-1.361,17.33s6.135-6.837,7.712-13.246c1.511-6.143,1.541-10.071-2.9-17.057",
  transform: "translate(-41.929 -46.615)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
})));

var SvgPoresIcon = function SvgPoresIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67.911,
    height: 64.699,
    viewBox: "0 0 67.911 64.699",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPoresIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pores-icon.3676eccb.svg";
export { ForwardRef as ReactComponent };